/**
 * The new first screen of onboarding (PIVOT-075): a low-friction "what
 * brings you here" choice, mirroring assistant-style onboarding, ahead of
 * consent + CV upload. The selection is threaded into the interview's first
 * turn (`InterviewChat` → `streamInterview`), not the finalize payload — see
 * PIVOT-075/PIVOT-076.
 */

import { useI18n } from '../i18n'
import type { TranslationKey } from '../i18n/types'
import type { OnboardingIntent } from '../types/domain'
import './IntentSelect.css'

interface IntentSelectProps {
  onSelect: (intent: OnboardingIntent) => void
}

const OPTIONS: { value: OnboardingIntent; labelKey: TranslationKey }[] = [
  { value: 'pivot_new_sector', labelKey: 'onboarding.intentPivotNewSector' },
  { value: 'same_sector_new_role', labelKey: 'onboarding.intentSameSectorNewRole' },
  { value: 'know_direction', labelKey: 'onboarding.intentKnowDirection' },
  { value: 'unsure', labelKey: 'onboarding.intentUnsure' },
]

export function IntentSelect({ onSelect }: IntentSelectProps) {
  const { t } = useI18n()

  return (
    <div className="stack">
      <h2>{t('onboarding.intentTitle')}</h2>
      <p className="intent-select-body">{t('onboarding.intentBody')}</p>
      <div className="intent-select-options" role="group" aria-label={t('onboarding.intentTitle')}>
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className="intent-option"
            onClick={() => onSelect(option.value)}
          >
            {t(option.labelKey)}
          </button>
        ))}
      </div>
    </div>
  )
}
